export default {
  name: 'ControlBase',
  props: {
    // take ref define from vue parent component
    inputRef: { type: String, default: () => null },
    // v-model passed to current control
    value: { type: null, default: () => null },
  },
  // sync changes from inside to vue v-model
  // throught input event
  setValue(parent, listeners, e) {
    const val = e.target.value
    listeners.input ? listeners.input(val) : null
    parent.$emit('validate')
    return val
  },
  bindClass: data => [data.staticClass, data.class],
  bindAttrs: data => {
    const attrs = data.attrs
    attrs.autocomplete = (Math.random() * 100000).toString()
    return attrs
  },

  bindListeners: listeners => {
    // input is not allow to direct bind because
    // we need it for handle input typing
    const filteredKeys = Object.keys(listeners).filter(key => key !== 'input')
    if (filteredKeys.length === 0) return {}
    else {
      return filteredKeys.reduce(
        (prev, key) => Object.assign(prev, { [key]: listeners[key] }),
        {},
      )
    }
  },
}
